import { Injectable } from '@angular/core';
import { OCPPService } from './ocpp.service';
import { HttpClient } from '@angular/common/http';
import { GetLocalListVersionRequest } from '../models/GetLocalListVersionRequest';
import { SendLocalListRequest } from '../models/SendLocalListRequest';

@Injectable()
export class LocalAuthorizationListManagementService extends OCPPService {

    private GET_LOCAL_LIST_VERSION_ENDPOINT = '/get-local-list-version';
    private SEND_LOCAL_LIST_ENDPOINT = '/send-local-list-version';

    getProfileBasePath(): string {
        return '/operations/local-authorization-list-management';
    }

    constructor(private http: HttpClient) {
        super();
    }

    public getLocalListVersion(data: GetLocalListVersionRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.GET_LOCAL_LIST_VERSION_ENDPOINT, data);
    }

    public sendLocalList(data: SendLocalListRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.SEND_LOCAL_LIST_ENDPOINT, data);
    }

}


